<template>
  <div class="job-manager-wrapper pa-10 pt-0">
    <tab-navigation
        :title="$t('job-manager.job-manager')"
        icon="ico-carplug"
        :description="$t('job-manager.description')"
        :breadcrumbs="[
          {text: $t('job-manager.job-manager')},
        ]"
    >
      <v-tabs>
        <v-tab :to="{name: 'job-manager.dashboard'}" exact>
          <v-icon left>mdi-view-dashboard</v-icon>
          {{ $t('job-manager.dashboard.tab') }}
        </v-tab>
        <v-tab :to="{name: 'job-manager.jobs'}">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          {{ $t('job-manager.jobs') }}
        </v-tab>
        <v-tab :to="{name: 'job-manager.failed'}">
          <v-icon left>mdi-alert-circle</v-icon>
          {{ $t('job-manager.failed-jobs.tab') }}
        </v-tab>
        <v-tab :to="{name: 'job-manager.schedules'}">
          <v-icon left>mdi-calendar-clock</v-icon>
          {{ $t('job-manager.schedules.tab') }}
        </v-tab>
      </v-tabs>
    </tab-navigation>


    <router-view></router-view>
  </div>
</template>

<script>
import TabNavigation from "@blocks/TabNavigation.vue";

export default {
  name: 'JobManager',
  components: {
    TabNavigation
  }
};
</script>

<style lang="scss" scoped>
.job-manager-wrapper {
  // Custom styles for job manager if needed
}
</style>
